module.exports = __webpack_public_path__ + "static/img/cp-top.a55c1432.png";